<template>
  <div class="product">
      <div class="product_topdesc">
          <div class="product_topdescbox">
              <div class="product_right">
                <img class="product_desccompany phone" :src="spuVO.madeFactoryLogo" alt="">
                <img class="pd" :src="spuVO.spuDetailImg" alt="">
              </div>
              <div class="product_descleft">
                <img class="product_desccompany pc" :src="spuVO.madeFactoryLogo" alt="">
                <div class="medicine_name">{{ spuVO.spuName }}</div>
                <div class="product_descdetail">{{ spuVO.spuIntroduce }}</div>
                <div class="plabel_box">
                    <span
                    v-for="item in spuVO.cgmLabelList"
                    :key="item.labelId"
                    class="product_lable"
                  >
                    {{ item.labelName }}
                  </span>
                    <!-- <span
                      class="product_lable"
                      v-for="item in spuVO.cgmSpuOptionList"
                      :key="item.spuOptionId"
                    > -->
                    <span class="product_lable">
                      包装 <span 
                  v-for="item in spuVO.cgmSpuOptionList"
                :key="item.labelId"> {{ item.optionValue }}{{ item.optionName }}</span>
                  </span>
                </div>
                <div class="product_descshare">
                    分享：
                    <img src="../assets/img/1.png" alt="" @click="sharenow">
                    <img src="../assets/img/2.png" alt="" @click="sharenow">
                    <img src="../assets/img/3.png" alt="" @click="sharenow">
                </div> 
            </div>
          </div>
      </div>
      <div class="product_detail">
        <div class="product_detail_content">
          <div class="product_detail_box">
            <div class="product_detail_tit">特长</div>
            <div v-html="spuVO.spuSpeciality"></div>
          </div>
          <div class="product_detail_box">
            <div class="product_detail_tit">使用注意事项</div>
            <div v-html="spuVO.spuCareful"></div>
          </div>
          <div class="product_detail_box">
            <div class="product_detail_tit">用法・剂量</div>
            <div v-html="spuVO.spuDosage"></div>
          </div>
          <div class="product_detail_box">
            <div class="product_detail_tit">功效・效果</div>
            <div v-html="spuVO.spuEffect"></div>
          </div>
          <div class="product_detail_box">
            <div class="product_detail_tit">成分・分量</div>
            <div v-html="spuVO.spuComponent"></div>
          </div>
          <div class="product_detail_box">
            <div class="product_detail_tit">存放和处理注意事项</div>
            <div v-html="spuVO.deposit"></div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      spuVO: {},
    };
  },
  props: {
    bgColor: {
      type: String,
      default: 'red', //
    },
  },
  mounted() {
    this.spu_detail();
  },
//   beforeCreate(){
//     document.querySelector('.footer').setAttribute('style','background:#F5F4F2')
//     document.querySelector('.foo_style').setAttribute('style','background:#fff')
//  },
  methods: {
    question_click() {
      this.$router.push({
        path: "/question",
      });
    },
    spu_detail() {
      this.axios
        .get("/cgmSpu/get", {
          params: {
            spuId: this.$route.query.spuId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.spuVO = res.data.data;
          }
        });
    },
    sharenow(){
      if (navigator.share) {
         navigator.share({
            title: document.title,
            text: "Hello World",
            url: "https://developer.mozilla.org",
         })
         .then(() => console.log("分享成功"))
         .catch((error) => console.error("分享失败：", error));
      } else {
        alert("当前浏览器不支持，请尝试其他浏览器");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.foo_style{
  background: #fff!important;
}
@media (max-width:768px) {
  .media_img_style {
    width: 307px;
  }
  .spu_title_style {
    font-size: 6vw !important;
    // padding: 23px 16px 10px !important;
  }
  .spu_detail_style > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }
  .spu_detail_style {
    padding: 12px !important;
  }
  .special_style {
    padding: 10px !important;
  }
  .special_layout_style {
    flex-wrap: wrap !important;
  }
  .spu_intro_style {
    padding: 40px;
  }
  .lable_style {
    background: #e9eff5 !important;
  }
  .question_style {
    box-sizing: border-box;
    padding: 40px;
    margin: unset !important;
  }
  .spu_style {
    flex-wrap: wrap;
    // padding: 10px !important;
    padding: unset !important;
  }
  .spu_right_style {
    padding: 0px 11px !important;
  }
  .box_style::after {
    right: -73px !important;
  }
  .mo_line_style {
    display: flex;
    margin-bottom: 20px;
  }
  .mo_line_itme_style {
    border-right: 2px solid #dcdcdc;
    font-size: 4vw;
    width: 50%;
    text-align: center;
    padding: 10px 0;
  }
  .mo_line_itme_style1 {
    font-size: 4vw;
    width: 50%;
    text-align: center;
    padding: 10px 0;
  }
  .special_layout_style {
    display: none !important;
  }
}
@media (min-width:768px) {
  .mob_line_style {
    display: none !important;
  }
}
.new_img_style {
  position: absolute;
  top: 0;
  left: 0;
}
.new_img_style1 {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 100px;
  height: 40px;
}
.question_style {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px 0;
}
.question_layout_style {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: #00519f;
  font-size: 18px;
  font-weight: 700;
  border: 1px solid #00519f;
  border-radius: 4px;
  width: 440px;
  height: 100px;
  cursor: pointer;
}
.fo_style {
  margin-bottom: 100px;
}
::v-deep table {
  width: 100%;
  border-collapse: collapse;
}
::v-deep table tr:first-child {
  height: 50px;
  text-align: center;
  background: rgb(231, 231, 231);
}
::v-deep td {
  border: 1px solid #bfc7d4;
}
::v-deep td:not(:nth-child(1):nth-child(2)) {
  padding: 14px;
}
.table_style1 {
  margin-bottom: 60px;
}
.table_style2 {
  margin-bottom: 70px;
}
.some_style {
  margin-bottom: 20px;
}
.num_style {
  padding-left: 20px;
  text-indent: -2em;
  margin-left: 2em;
}
.store_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  margin: 14px 0;
  font-size: 20px;
  margin-bottom: 40px;
}
.st_style {
  margin-bottom: 10px;
  text-indent: -2em;
  margin-left: 2em;
}
.component_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  margin: 14px 0;
  font-size: 20px;
  margin-bottom: 40px;
}
.weight_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  margin: 14px 0;
  font-size: 20px;
  margin-bottom: 40px;
}
.please_style {
  margin-bottom: 20px;
}
.three_style {
  margin-bottom: 100px;
}
.four_style {
  margin-bottom: 20px;
}
.com_style {
  margin-bottom: 100px;
}
.effect_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  margin: 14px 0;
  font-size: 20px;
}
.ef_style {
  margin: 40px 0 60px 0;
}
.eat_style {
  margin: 14px 0;
}
.need_style {
  margin: 14px 0;
}
.spu_detail_style {
  // background-image: url(../assets/img/pd_bg.jpg);
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.spu_style {
  display: flex;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid #cccccc;
  box-sizing: border-box;
  margin: 0 0 80px;
  padding: 40px 25px 20px;
}
.special_style {
  border: 1px solid #cccccc;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 60px;
  box-sizing: border-box;
}
.special_layout_style {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 40px;
}
.special_layout_style > div {
  border-right: 2px solid #dcdcdc;
  height: 40px;
  line-height: 40px;
  padding: 0 30px;
}
.special_layout_style > div:last-child {
  border-right: unset;
}
.special_text_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  padding: 0 0 6px;
  font-size: 20px;
  margin-bottom: 30px;
}
.ease_style {
  margin-bottom: 60px;
}
.use_style {
  color: #00519f;
  border-bottom: 2px solid #959595;
  font-size: 20px;
  margin-bottom: 40px;
  padding: 4px;
}
.use_img_style {
  width: 34px;
  vertical-align: middle;
}
.spu_left_style {
  flex: 1;
  // padding: 40px;
  background: #fff;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  line-height: 30px;
  padding: 3vw;
  position: relative;
}
.spu_intro_style {
  // margin-bottom: 20px;
  font-size: 16px;
  text-align: center;
  margin: 20px auto 5px;
}
.spu_right_style {
  flex: 1;
  padding: 0 30px;
}
.wrap_style {
  height: 47px;
  line-height: 47px;
  background: #00519f;
  color: #fff;
  font-weight: bold;
  text-align: center;
}
.right_layout_style {
  margin-bottom: 20px;
}
.ch_right_layout_style {
  margin-bottom: 47px;
}
.box_style {
  position: relative;
}
.box_style:not(:last-child):after {
  content: "";
  width: 1px;
  height: 34px;
  background-color: #bfbfbf;
  position: absolute;
  right: -111px;
  top: -7px;
}
.china_layout_style {
  margin-bottom: 26px;
  height: 44px;
}
.unit_style {
  display: flex;
  justify-content: space-around;
  font-size: 17px;
}
.china_style {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.china_name_style {
  color: #1b2a7e;
  font-size: 30px;
  font-weight: bold;
}
.lable_layout_style {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}
.lable_style {
  padding: 14px 20px;
  font-size: 9px;
  color: #1b2a7e;
  background-color: #fff;
  border-radius: 25px;
}
.spu_title_style {
  color: #fff;
  font-size: 34px;
  padding: 44px 0;
  text-align: center;
}
.spu_detail_style > div {
  max-width: 1150px;
}
//   新的商品详情
*{
  box-sizing: border-box;
}
.product_topdesc{
      background: #005EB2;
      padding:132px 0 100px;
     
  }
  .product_topdescbox{
    width:1145px;
    margin:0 auto;
    overflow: hidden;
    zoom:1;
  }
  .product_desccompany.phone{
    display: none;
  }

  .product_descleft{
    width: 524px;
    margin-right: 80px;
    float: right;
  }
  .product_right{
    padding-top: 70px;
    float: right;
    vertical-align: top;
  }
  .product_desccompany{
    width: 170px;
    display: block;
    margin-bottom: 25px;
  }
  .product_descdetail{
    font-size: 20px;
    font-weight: bold;
    line-height: 40px;
    color:#fff;
    margin-bottom: 100px;
  }
  .product_lable{
    display: inline-block;
    font-size: 20px;
    color:#005EB2;
    padding:10px 20px;
    margin-right: 18px;
    background: #fff;;
    border-radius:23px;
    margin-bottom: 10px;
  }
  .product_lable:last-child(1){
    margin-right: 0;
  }
  .product_descshare{
    font-size: 20px;
    color:#fff;
    margin-top: 30px;
    font-weight: bold;
  }
  .product_descshare img{
    display: inline-block;
    width:30px;
    margin-right:10px;
    vertical-align: middle;
  }
  .product_right img.pd{
    width: 500px;
  }
  .product_detail{
    background: #F5F4F2;
    padding:40px 0 70px;
  }
  .product_detail_content{
    width: 1212px;
    margin:0 auto;
  }
  .product_detail_box{
    padding:35px 35px 35px 60px;
    background: #fff;
    border-radius: 20px;
    margin-bottom: 30px;
  }
  .product_detail_tit{
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .medicine_name{
    font-size: 35px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 25px;
  }
  @media screen and (max-width:1250px) {
    .product_descleft{
      width: 48%;
      margin-right: 4%;
    }
    .product_right{
      width: 48%;
    }
    .product_right img.pd{
      display: block;
      margin:0 auto;
      width: 250px;
    }
    .product_topdescbox{
      width:90%;
    }
    .product_detail_content{
      width: 90%;
    }
  }
  @media screen and (max-width: 768px) { 
    .product_topdesc{
      padding:40px 0;
    }
    .product_desccompany{
      width: 35%;
      margin-bottom: 15px;
    }
     .product_descleft{
      width:100%;
      margin-right: 0;
     }
     .product_desccompany.pc{
      display: none;
    }
     .product_desccompany.phone{
      display: block;
      width:100px;
    }
     .product_descdetail{
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 24px;
     }
     .product_lable{
      padding:5px 10px;
      font-size: 14px;
      margin-right: 10px;
     }
     .product_descshare{
     margin-top: 20px;
     font-size: 15px;
     }
     .medicine_name{
      font-size: 25px;
     }
     .product_right{
      width: 100%;
      padding-top: 0;
      margin-bottom: 20px;
     }
     .product_detail_box{
      padding:20px 15px;
     }
     .product_detail_tit{
      font-size: 18px;
     }
  }
</style>